module.exports = __webpack_public_path__ + "img/user.27fcf24e.png";